import { css } from '../../styles/theme';
import { rem } from 'polished';

export const StylesAC = css`
    &:first-child a {
        color: ${({ theme }) => theme.colors.grey5} !important;
    }
`;
